{
  "agb-dialog": {
    "text": {
      "agb": "Allgemeine Geschäftsbedingungen"
    },
    "buttons": {
      "close": "Schließen"
    }
  }
}
